<template>
  <div class="AstaResult">
    <Filter @display-change="(d) => updateStatus(d)" @filter-change="(f) => updateStatus(f)" />
    <div id="ScrollTarget"></div>
    <SearchHeader v-if="astaStore.result" :heading="astaStore.texter.searchresultblock.searchresult"
      :hits="astaStore.texter.searchresultblock.hits" :results="astaStore.antalObjekt"
      :url="astaStore.texter.SearchApiAdress" :vy="astaStore.display.vy" />
    <InfoView class="desktopOnly" :promptText="promptText" :text="astaStore.infoText" />
    <div style="position: relative">
      <div class="SearchResultat" aria-live="polite">
        <ResultHeader />
        <Item v-for="item in astaStore.result" :item="item" />
      </div>
      <div class="loader-container" :style="{ display: astaStore.resultsLoading ? 'flex' : 'none' }">
        <div class="loader"></div>
      </div>
      <Footer></Footer>
    </div>
    <SaveButtons class="mobileOnly" :vy="astaStore.display.vy" :url="astaStore.texter.SearchApiAdress"
      :isDisabled="astaStore.antalObjekt <= 0 || astaStore.settings.disableDownload"></SaveButtons>
  </div>
</template>
<script setup lang="ts">
import { onMounted, ref } from 'vue';
import type { AstaDisplaySettings, AstaFilterSettings } from '../../types/AstaTypes';
import useAstaStore from '../stores/AstaStore';
import Filter from './Filter.vue';
import ResultHeader from './ResultHeader.vue';
import SaveButtons from './saveButtons.vue';
import SearchHeader from './SearchHeader.vue';
import InfoView from './InfoView.vue';
import Item from './Item.vue';
import Footer from './Footer.vue';

const promptText = ref(Asta.Texter.PromtText);
const astaStore = useAstaStore();
astaStore.init(Asta, AstaResultatStatus);

onMounted(() => {
  astaStore.search(true, true);
});

const updateStatus = (status: AstaDisplaySettings | AstaFilterSettings) => {
  console.log('result:updateStatus:', status);
};
</script>
